/* ==========================================================================
   Collection sidebar (sections/main-collection.liquid)

   From 992px the filters are a column beside the products (see
   assets/collection-sidebar.css) and the "Filter products" pill in the top
   bar is its label. A click on the pill then scrolls the page so the column
   sits just below the fixed header, instead of opening the drawer.

   The drawer is opened by a direct jQuery click handler on
   .js-open-collection-filter in assets/theme.js. This listener runs first,
   in the capture phase on document, and stops the click there, so that
   handler never runs and no drawer or overlay class is added. Below 992px it
   does nothing and the pill and the bottom bar's "Filter" button open the
   drawer as before. Filtering, sorting and Load more do not replace the top
   bar. Even if they did, this listener is on document, so it would keep
   working.
   ========================================================================== */
(function () {
  /* Keep 992px in step with the min-width: 992px media queries in
     assets/collection-sidebar.css */
  var columnLayout = window.matchMedia('(min-width: 992px)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', function (event) {
    if (!columnLayout.matches) return;
    if (!event.target.closest) return;

    var pill = event.target.closest('.collection__filter-and-sort .js-open-collection-filter');
    if (!pill) return;

    var sidebar = document.querySelector('.collection-sidebar');
    if (!sidebar) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    /* The header height the column sticks below, set per width in
       assets/collection-sidebar.css */
    var headerHeight = parseFloat(getComputedStyle(sidebar).getPropertyValue('--collection-sidebar-top')) || 0;
    var top = sidebar.getBoundingClientRect().top + window.pageYOffset - headerHeight;

    window.scrollTo({
      top: Math.max(0, Math.round(top)),
      behavior: reducedMotion.matches ? 'auto' : 'smooth'
    });
  }, true);
})();
